import type { Context } from 'react';
import { createContext } from 'react';

export const defaultLocale = 'en-US';

export const LocaleContext: Context<string> = createContext<string>(defaultLocale);
